// Updated CheckoutForm.jsx with dashboard-style look
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { useState } from 'react';
import './CheckoutForm.css';

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) return;

    setProcessing(true);
    const data = JSON.parse(localStorage.getItem('Data'));

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/payment-success`,
        payment_method_data: {
          billing_details: {
            name: `${data.customerFirstName} ${data.customerLastName}`,
            email: data.email,
            address: {
              line1: data.addressLine1,
              line2: data.addressLine2 || '',
              city: data.city,
              state: data.state,
              postal_code: data.zipCode,
              country: 'US',
            },
          },
        },
      },
    });

    if (result.error) {
      console.log("Error - ", result.error.message);
      setProcessing(false);
    } else {
      console.log("Success 🎉");
    }
  };

  return (
    <div className="dashboard-wrapper checkout-container">
      <div className="checkout-card">
        <h4 className='display-4 text-center' id='main-font'>Complete Your Payment</h4>
        <form onSubmit={handleSubmit}>
          <PaymentElement />
          <button className="pay-button" id='main-font' disabled={!stripe || !elements || processing}>
            {processing ? 'Processing...' : 'Pay Now'}
          </button>
        </form>
      </div>

      <div className="powered-by-stripe" id='main-font'>Powered by Stripe</div>
    </div>

  );
};

export default CheckoutForm;
